export default () => {
    return {
        animating: false,

        mounted() {
            gsap.set(this.$refs.arrow, { yPercent: 104 });
        },

        hover() {
            if (!this.animating) {
                this.animating = true;

                const tl = gsap.timeline({
                    onComplete: () => {
                        this.animating = false;
                    }
                });

                tl.fromTo(this.$refs.arrow, { yPercent: 104 }, { duration: 0.3, yPercent: 0, ease: 'quint.out' });
            }
        },

        leave() {
            this.animating = true;

            const tl = gsap.timeline({
                onComplete: () => {
                    this.animating = false;
                }
            });

            tl.to(this.$refs.arrow, { duration: 0.3, yPercent: -104, ease: 'quint.inOut' });
        }
    };
};
